<script lang="ts" setup>
import { LoadingSpinner, Modal } from "@/components";
import { onMounted, ref } from "vue";

const status = ref<HTMLElement>();

onMounted(() => {
  status.value?.focus();
});

const containFocus = (event: KeyboardEvent) => {
  if (event.key !== "Tab") {
    return;
  }

  event.preventDefault();
  event.stopPropagation();
  status.value?.focus();
};
</script>

<template>
  <Modal
    :active="true"
    :closeDisabled="true"
    shrinkToContent
    class="hide_close"
    role="dialog"
    aria-modal="true"
    :aria-label="$t('documentSpace.checkingConsent.title')"
    @keydown="containFocus"
  >
    <template #header>
      {{ $t("documentSpace.checkingConsent.title") }}
    </template>

    <template #body>
      <div
        ref="status"
        class="consent_check_state"
        role="status"
        aria-live="polite"
        aria-busy="true"
        tabindex="-1"
      >
        <LoadingSpinner :color="'var(--classic-text, black)'" />
        <p>{{ $t("documentSpace.checkingConsent.message") }}</p>
      </div>
    </template>
  </Modal>
</template>

<style scoped>
.consent_check_state {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.consent_check_state p {
  margin: 0;
}
</style>
